import { render, staticRenderFns } from "./approveModal.vue?vue&type=template&id=58ba206f&scoped=true&"
import script from "./approveModal.vue?vue&type=script&lang=js&"
export * from "./approveModal.vue?vue&type=script&lang=js&"
import style0 from "./approveModal.vue?vue&type=style&index=0&id=58ba206f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ba206f",
  null
  
)

export default component.exports